/**
 * Charm Builder — Cart Note Sync
 *
 * Removal-side counterpart to charm-builder-cart.js's _noteCartAsCharmBuilder().
 * That function stamps cart.note when a Charm Builder set is added; this
 * script strips the stamp back out once no charm-builder line items
 * (properties._charmbuilderitem) remain in the cart.
 *
 * Covers removal/quantity-to-zero from both the cart page and the cart
 * drawer — both share the same CartItemsComponent → /cart/change.js →
 * 'cart:update' path (see assets/component-cart-items.js), so a single
 * document-level listener sees every removal regardless of surface.
 *
 * Best-effort: failures here never surface to the customer.
 */
(function () {
  "use strict";

  // Must match assets/charm-builder-cart.js's CART_NOTE_TEXT exactly.
  const CART_NOTE_TEXT =
    "This order contains a custom Charm Builder necklace set — please pack all charm set items together.";

  function _hasCharmBuilderItems(cart) {
    return (cart.items || []).some(item => item.properties && item.properties._charmbuilderitem);
  }

  function _stripNote(note) {
    return note
      .split("\n")
      .filter(line => line.trim() !== CART_NOTE_TEXT)
      .join("\n")
      .trim();
  }

  async function _getCart() {
    const res = await fetch(window.Shopify.routes.root + "cart.js");
    return res.json();
  }

  async function _maybeRemoveNote(cart) {
    if (_hasCharmBuilderItems(cart)) return;

    const existing = cart.note || "";
    if (!existing.includes(CART_NOTE_TEXT)) return;

    const note = _stripNote(existing);
    await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note }),
    });
  }

  document.addEventListener("cart:update", event => {
    // event.detail.resource is the full updated cart JSON for real
    // cart-items-component-driven changes (add/qty-change/remove); other
    // dispatchers (e.g. awe-cart-membership) pass an empty resource, so
    // fall back to fetching /cart.js in that case.
    const resource = event.detail && event.detail.resource;
    const cartPromise =
      resource && Array.isArray(resource.items) ? Promise.resolve(resource) : _getCart();

    cartPromise.then(_maybeRemoveNote).catch(function () {
      // Non-critical — worst case the note lingers until the next cart change.
    });
  });
})();
